(function(){
  if(window.__bmpDrawerInit)return;window.__bmpDrawerInit=true;
  var CONTENT={
    livraison:{
      title:'Livraison offerte, expédiée en 24/48h',
      html:'<h3>Expédition depuis Joigny (89)</h3>'+
           '<p>Votre commande est expédiée en 24/48h (jours ouvrés) depuis notre atelier, puis livrée en 2 à 4 jours ouvrés.</p>'+
           '<h3>Transporteurs partenaires</h3>'+
           '<p>Chronopost et Mondial Relay en France, UPS pour l’Union européenne continentale et l’express vers les îles. Vous recevez un numéro de suivi par e-mail dès l’expédition, avec mises à jour en temps réel.</p>'+
           '<h3>Emballage renforcé</h3>'+
           '<p>Chaque appareil part dans un carton renforcé avec calage bulle sur mesure. Votre PC portable arrive dans les mêmes conditions qu’il quitte notre atelier.</p>'+
           '<h3>Livraison offerte, sans minimum d’achat</h3>'+
           '<p>La livraison standard est offerte sans minimum d’achat en France et dans les pays de l’Union européenne continentale desservis.</p>'+
           '<h3>Modes de livraison en France métropolitaine</h3>'+
           '<p><strong>Livraison à domicile Chronopost</strong> : offerte. Expédié en 24/48h, livré en 2 à 4 jours ouvrés.</p>'+
           '<p><strong>Point relais Chronopost ou Mondial Relay</strong> : offert. Expédié en 24/48h, livré en 3 à 5 jours ouvrés en point relais.</p>'+
           '<p><strong>Express à domicile Chronopost</strong> : 15 €. Traitement prioritaire, livré en 1 à 2 jours ouvrés.</p>'+
           '<h3>Union européenne</h3>'+
           '<p><strong>UPS Standard</strong> : offerte. Expédié en 24/48h, livré en 2 à 4 jours ouvrés.</p>'+
           '<p><strong>UPS Express</strong> : 15 €. Livré en 1 à 2 jours ouvrés.</p>'+
           '<h3>Îles de l’Union européenne</h3>'+
           '<p>Baléares, Canaries, Sicile, Malte, Açores et Madère.</p>'+
           '<p><strong>Standard</strong> : 35 €. Livré en 5 à 8 jours ouvrés.</p>'+
           '<p><strong>UPS Express</strong> : 45 €. Livré en 3 à 5 jours ouvrés.</p>'
    },
    retour:{
      title:'Retour gratuit sous 14 jours',
      html:'<h3>Vous changez d’avis ?</h3>'+
           '<p>Pas de souci. Vous avez <strong>14 jours</strong> à compter de la réception pour nous renvoyer votre appareil, sans avoir à vous justifier.</p>'+
           '<h3>Comment ça marche</h3>'+
           '<p>1. Faites votre demande depuis l’<a href="/pages/sav" style="color:#E3A600;font-weight:700;text-decoration:underline;">Espace SAV</a> ou par e-mail à <strong>contact@beemac.fr</strong>.<br>'+
           '2. Nous vous envoyons une <strong>étiquette retour prépayée</strong> sous 24h.<br>'+
           '3. Renvoyez votre PC portable dans l’emballage d’origine, bien protégé.<br>'+
           '4. Dès réception, on vérifie l’appareil et on vous rembourse <strong>sous 2 jours</strong>.</p>'+
           '<h3>Retour offert</h3>'+
           '<p>Aucun frais à votre charge, l’étiquette de renvoi est prise en charge par BEEMAC.</p>'
    },
    garantie:{
      title:'Garantie 12 mois BEEMAC',
      html:'<h3>Une panne dans les 12 premiers mois ?</h3>'+
           '<p>Si votre PC portable rencontre un problème matériel pendant la période de garantie commerciale, on s’en occupe. Batterie, alimentation, écran, carte mère, clavier, tout est couvert.</p>'+
           '<h3>Batterie</h3>'+
           '<p>Chaque batterie est testée avec une <strong>capacité minimum de 80 %</strong>. Pendant toute la durée de votre garantie (12 mois, ou 24 mois avec une extension Premium ou Premium+), la batterie est prise en charge si elle est défectueuse ou si sa capacité descend sous 80 %.</p>'+
           '<h3>Comment nous joindre</h3>'+
           '<p>Un e-mail à <strong>contact@beemac.fr</strong> ou un appel au <strong>06 52 64 41 42</strong>. Notre atelier répond sous 24h, en français, sans robot ni hotline.</p>'+
           '<h3>Réparation ou remplacement</h3>'+
           '<p>Selon le problème, on répare directement dans notre atelier de Joigny (89), ou on vous remplace l’appareil si la réparation n’est pas possible. Retour pris en charge par nos soins.</p>'+
           '<h3>Ce qui n’est pas couvert</h3>'+
           '<p>Certaines situations ne relèvent pas de la garantie commerciale :</p>'+
           '<p>Chutes, chocs, projection de liquide, ouverture ou réparation par un tiers, utilisation non conforme (chargeur non compatible, environnement inadapté), pannes logicielles ou virus installés après achat.</p>'+
           '<p><a href="/blogs/conseils-guides/garantie" style="color:#E3A600;font-weight:700;text-decoration:underline;">Consulter le détail complet des conditions et exclusions</a></p>'+
           '<h3>Garantie légale de conformité</h3>'+
           '<p>En plus des <strong>12 mois de garantie commerciale BEEMAC</strong>, vous bénéficiez de la <strong>garantie légale de conformité de 24 mois</strong> prévue par le Code de la consommation, applicable dès la livraison.</p>'
    },
    retour_film:{
      title:'Film découpé sur mesure',
      html:'<h3>Pas de droit de rétractation</h3>'+
           '<p>Le film étant découpé sur mesure pour votre modèle, il n’est pas concerné par le droit de rétractation (article L221-28 3° du Code de la consommation).</p>'+
           '<h3>Défaut ou erreur de modèle</h3>'+
           '<p>S’il est défectueux ou ne correspond pas au modèle indiqué dans votre commande, nous le remplaçons ou vous remboursons, <strong>retour à nos frais</strong>.</p>'+
           '<h3>Comment nous joindre</h3>'+
           '<p>Depuis l’<a href="/pages/sav" style="color:#E3A600;font-weight:700;text-decoration:underline;">Espace SAV</a>, par e-mail à <strong>contact@beemac.fr</strong> ou au <strong>06 52 64 41 42</strong>.</p>'
    },
    garantie_film:{
      title:'Garantie 3 mois BEEMAC',
      html:'<h3>Garantie commerciale BEEMAC</h3>'+
           '<p>Votre film hydrogel est couvert <strong>3 mois</strong> par la garantie commerciale BEEMAC.</p>'+
           '<h3>Comment nous joindre</h3>'+
           '<p>Un e-mail à <strong>contact@beemac.fr</strong> ou un appel au <strong>06 52 64 41 42</strong>.</p>'+
           '<h3>Garantie légale de conformité</h3>'+
           '<p>En plus des <strong>3 mois de garantie commerciale BEEMAC</strong>, vous bénéficiez de la <strong>garantie légale de conformité de 2 ans</strong> prévue par le Code de la consommation, applicable dès la livraison.</p>'
    },
    garantie_legale:{
      title:'Garantie légale de conformité 2 ans',
      html:'<h3>Produit neuf</h3>'+
           '<p>Ce produit bénéficie de la <strong>garantie légale de conformité de 2 ans</strong> prévue par le Code de la consommation, applicable dès la livraison.</p>'+
           '<h3>Comment nous joindre</h3>'+
           '<p>Un e-mail à <strong>contact@beemac.fr</strong> ou un appel au <strong>06 52 64 41 42</strong>.</p>'
    },
    garantie_chargeur:{
      title:'Garantie 6 mois BEEMAC',
      html:'<h3>Garantie commerciale BEEMAC</h3>'+
           '<p>Votre chargeur neuf est couvert <strong>6 mois</strong> par la garantie commerciale BEEMAC, qui prend en charge ses défauts de fonctionnement.</p>'+
           '<h3>Comment nous joindre</h3>'+
           '<p>Un e-mail à <strong>contact@beemac.fr</strong> ou un appel au <strong>06 52 64 41 42</strong>.</p>'+
           '<h3>Garantie légale de conformité</h3>'+
           '<p>En plus des <strong>6 mois de garantie commerciale BEEMAC</strong>, vous bénéficiez de la <strong>garantie légale de conformité de 2 ans</strong> prévue par le Code de la consommation, applicable dès la livraison.</p>'
    }
  };
  function createDrawer(){
    if(document.getElementById('bmp-drawer'))return;
    var d=document.createElement('div');
    d.id='bmp-drawer';d.className='bmp-drawer';
    d.innerHTML='<div class="bmp-drawer-backdrop"></div><div class="bmp-drawer-panel" role="dialog" aria-modal="true"><button class="bmp-drawer-close" aria-label="Fermer"><svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" style="pointer-events:none;vertical-align:middle"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button><h2 class="bmp-drawer-title"></h2><div class="bmp-drawer-body"></div></div>';
    document.body.appendChild(d);
    d.querySelector('.bmp-drawer-backdrop').addEventListener('click',close);
    d.querySelector('.bmp-drawer-close').addEventListener('click',close);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  }
  function open(key){
    if(!CONTENT[key])return;
    createDrawer();
    var d=document.getElementById('bmp-drawer');
    d.querySelector('.bmp-drawer-title').textContent=CONTENT[key].title;
    d.querySelector('.bmp-drawer-body').innerHTML=CONTENT[key].html;
    requestAnimationFrame(function(){d.classList.add('is-open');});
    document.body.style.overflow='hidden';
  }
  function close(){
    var d=document.getElementById('bmp-drawer');
    if(d)d.classList.remove('is-open');
    document.body.style.overflow='';
  }
  function run(){
    var blocks=document.querySelectorAll('.bmp-info-block');
    if(!blocks.length)return;
    var keys=['livraison','retour','garantie'];
    blocks.forEach(function(b,i){
      var key=b.dataset.bmpDrawer||keys[i];
      if(!key||!CONTENT[key])return;
      if(b.dataset.bmpDrawerBound)return;
      b.dataset.bmpDrawerBound='1';
      b.style.cursor='pointer';
      b.setAttribute('role','button');
      b.setAttribute('tabindex','0');
      b.addEventListener('click',function(){open(key);});
      b.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();open(key);}});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
